
import { TFunction } from 'react-i18next'
import { z } from 'zod'

const tConfig = {
  ns: 'verifyPassword'
}

export const createSchema = (t: TFunction) => {
  return z.object({
    password: z.string().min(1, t('validation.required', tConfig))
  })
}

export type VerifyPasswordFormData = z.infer<ReturnType<typeof createSchema>>
